import Cookies from "js-cookie";
import moment from "moment-timezone";
import { toast } from "react-toastify";

export const setAuthToken = (token: string) => {
  return Cookies.set("authToken", JSON.stringify(token));
};

export const removeAuthToken = () => {
  return Cookies.remove("authToken");
};

export const getAuthToken = () => {
  const authToken = Cookies.get("authToken");
  if (authToken) {
    return JSON.parse(authToken);
  }
};

export const formatBytes = (bytes: number) => {
  if (bytes === 0) return "0 B";

  const sizes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));

  return (bytes / Math.pow(1024, i)).toFixed(2) + " " + sizes[i];
};

export const objectToFormData = (
  data: any,
  formData = new FormData(),
  nestedKey = ""
) => {
  if (data === null || data === undefined) {
    return formData;
  }

  if (Array.isArray(data)) {
    data.forEach((item, index) => {
      objectToFormData(item, formData, `${nestedKey}[${index}]`);
    });
  } else if (typeof data === "object") {
    if (data?.type?.includes("image")) {
      formData.append(nestedKey, data);
    } else {
      for (let key in data) {
        if (data.hasOwnProperty(key)) {
          let formKey = nestedKey ? `${nestedKey}[${key}]` : key;

          objectToFormData(data[key], formData, formKey);
        }
      }
    }
  } else {
    formData.append(nestedKey, data);
  }

  return formData;
};

// getNestedError fuction will return the error from the nested field name joined with a dot
export const getNestedError = (errors: any, path: string) => {
  return path.split(".").reduce((acc, part) => acc && acc[part], errors);
};

export const cleanObject = (payload: Record<string, any>) => {
  Object.keys(payload).forEach((key) => {
    const value = payload[key];

    if (value && typeof value === "object" && !Array.isArray(value)) {
      cleanObject(value);
    }

    if (!value && value !== 0) {
      delete payload[key];
    }
  });
};

export const successToast = (content: any) => {
  toast.success(content, { autoClose: 20000 });
};

export const errorToast = (content: any, autoClose = 0) => {
  if (Array.isArray(content)) {
    content.forEach((msg: string) => {
      toast.error(msg, { autoClose: autoClose > 0 ? autoClose : 60000 });
    });
  } else {
    toast.error(content, { autoClose: autoClose > 0 ? autoClose : 60000 });
  }
};

export const formatLocalDate = (date?: string | Date): string =>
  date ? new Date(date).toISOString().split("T")[0] : "";

export const formatDateToUsPecificTimezone = (date: string) => {
  return moment
    .tz(date || moment(), "America/Los_Angeles")
    .format("YYYY-MM-DD");
};
export const formatTimeToUsPecificTimezone = (date: string) => {
  return moment.tz(date || moment(), "America/Los_Angeles").format("HH:mm");
};

export const setDragOnlyInStaging = <T>(tableColumns: T[]): T[] => {
  // if (!isStaging) tableColumns.shift();
  return tableColumns;
};

export const pathFormatting = (path: string) => {
  return path
    .split("/")
    .filter((x) => x)
    .map(
      (segment) =>
        segment
          .replace(/&/g, "and") // Replace '-&-' with 'and'
          .replace(/[\s_]+/g, "-") // Replace spaces & underscores with hyphens
    )
    .join("/");
};

export const isStaging = process.env.REACT_APP_SERVER === "development";
export const isPreProduction =
  process.env.REACT_APP_SERVER === "pre-production";
export const capitalize = (str?: string) =>
  str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : "";
export const convertToTimeInputFormat = (timeString: string): string => {
  if (!timeString) return "";

  // Normalize space around colon, e.g. "04 : 00 AM" -> "04:00 AM"
  const cleanedTimeString = timeString.replace(/\s*:\s*/, ":").trim();

  const [time, period] = cleanedTimeString.split(" ");
  if (!time || !period) return "";

  const [hoursStr, minutes] = time.split(":");
  let hours = parseInt(hoursStr);

  if (period.toUpperCase() === "PM" && hours < 12) hours += 12;
  if (period.toUpperCase() === "AM" && hours === 12) hours = 0;

  return `${String(hours).padStart(2, "0")}:${minutes}`;
};
export const convertTimeToAmPmFormat = (time: string) => {
  if (!time) return "";

  let [hours, minutes] = time.split(":").map((x) => parseInt(x));
  const period = hours >= 12 ? "PM" : "AM";

  if (hours === 0) hours = 12;
  else if (hours > 12) hours -= 12;

  return `${String(hours).padStart(2, "0")} : ${String(minutes).padStart(
    2,
    "0"
  )} ${period}`;
};
